<template>
  <div class="painel-container" @click="onPainelClick">
    <div class="banner">
      <div class="banner-content">
        <!-- conteúdo do banner -->
        <!-- <div class="title-container">
          <div class="title-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="flower-icon"
            >
              <circle cx="12" cy="12" r="3"></circle>
              <path
                d="M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5"
              ></path>
              <path d="M12 7.5V9"></path>
              <path d="M7.5 12H9"></path>
              <path d="M16.5 12H15"></path>
              <path d="M12 16.5V15"></path>
              <path d="m8 8 1.88 1.88"></path>
              <path d="M14.12 9.88 16 8"></path>
              <path d="m8 16 1.88-1.88"></path>
              <path d="M14.12 14.12 16 16"></path>
            </svg>
            <h1>Homenagens em Memória</h1>
          </div>
          <div class="logo-placeholder"></div>
        </div> -->
      </div>
    </div>

    <div class="cards-container">
      <v-container class="pt-0">
        <!-- Primeira linha: 3 cards -->
        <v-row class="flex-wrap" style="width: 100%">
          <transition-group
            name="card-transition"
            tag="div"
            class="d-flex flex-wrap"
            style="width: 100%"
          >
            <v-col
              v-for="(card, index) in primeiraLinhaCards"
              :key="card.id" 
              cols="4"
            >
              <v-card elevation="2" class="h-100" rounded="lg">
                <div class="card-header" :class="`gradient-${(index % 5) + 1}`">
                  <span class="nome-mae">{{ card.nomeHomenageado }}</span>
                </div>
                <v-card-text class="pa-4">
                  <p class="memorial-message">{{ card.mensagem }}</p>
                  <div class="memorial-author">
                    <div class="author-name">{{ card.nomeCliente }}</div>
                    <div class="author-date">
                      {{ formatDate(card.dataInclusao) }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </transition-group>
        </v-row>

        <!-- Segunda linha: 3 cards -->
        <v-row class="flex-wrap" style="width: 100%">
          
          <transition-group
            name="card-transition"
            tag="div"
            class="d-flex flex-wrap"
            style="width: 100%"
          >
            <v-col
              v-for="(card, index) in segundaLinhaCards"
              :key="card.id"
              cols="4"
            >
              <v-card elevation="2" class="h-100" rounded="lg">
                <div
                  class="card-header"
                  :class="`gradient-${((index + 3) % 5) + 1}`"
                >
                  <span class="nome-mae">{{ card.nomeHomenageado }}</span>
                </div>
                <v-card-text class="pa-4">
                  <p class="memorial-message">{{ card.mensagem }}</p>
                  <div class="memorial-author">
                    <div class="author-name">{{ card.nomeCliente }}</div>
                    <div class="author-date">
                      {{ formatDate(card.dataInclusao) }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </transition-group>
        </v-row>

        <!-- Terceira linha: 2 cards centralizados -->
        <v-row class="flex-wrap justify-center" style="width: 100%">
          <transition-group
            name="card-transition"
            tag="div"
            class="d-flex flex-wrap justify-center"
            style="width: 100%"
          >
            <v-col
              v-for="(card, index) in terceiraLinhaCards"
              :key="card.id"
              cols="12"
              sm="4"
              md="4"
              style="width: 300px; max-width: 33%"
            >
              <v-card elevation="2" class="h-100" rounded="lg">
                <div
                  class="card-header"
                  :class="`gradient-${((index + 6) % 5) + 1}`"
                >
                  <span class="nome-mae">{{ card.nomeHomenageado }}</span>
                </div>
                <v-card-text class="pa-4">
                  <p class="memorial-message">{{ card.mensagem }}</p>
                  <div class="memorial-author">
                    <div class="author-name">{{ card.nomeCliente }}</div>
                    <div class="author-date">
                      {{ formatDate(card.dataInclusao) }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </transition-group>
        </v-row>
      </v-container>
    </div>

    <!-- Overlay de vídeo ou imagem -->
    <transition name="fade">
      <div
        v-if="showPropaganda"
        class="video-overlay"
        @click.stop="pularPropaganda"
        title="Clique para pular"
      >
        <!-- Container para vídeos com transição suave -->
        <div v-if="tipoConteudoAtual === 'video'" class="video-container">
          <!-- Vídeo atual -->
          <video
            v-if="itemAtual"
            ref="videoPlayer"
            :src="itemAtual.url"
            class="video-player"
            @ended="proximoItem"
            @timeupdate="handleTimeUpdate"
            autoplay
            playsinline
            muted
          ></video>
          <!-- Pré-carregamento do próximo vídeo -->
          <video
            v-if="proximoVideoUrl"
            ref="nextVideoPlayer"
            :src="proximoVideoUrl"
            class="video-player next-video"
            preload="auto"
            muted
            style="display: none"
          ></video>
        </div>
        <!-- Exibe imagem -->
        <img
          v-if="tipoConteudoAtual === 'imagem' && itemAtual"
          :src="itemAtual.url"
          class="propaganda-image"
          @load="iniciarTimerImagem"
          @click.stop="pularPropaganda"
        />
      </div>
    </transition>
    <v-div class="qr-card">
      <QrcodeVue :value="qrCodeValue" size="180"></QrcodeVue>
    </v-div>

    <!-- <v-card class="qr-card" elevation="2" width="320" rounded="lg">
      <v-card-text class="pa-4">
        <div class="d-flex align-center gap-4">
          <div class="flex-grow-1">
            <p class="text font-weight-medium text-center pr-4">
              Aponte sua câmera para este QRCode e deixar sua mensagem!
            </p>
          </div>
          <QrcodeVue :value="qrCodeValue" size="100"></QrcodeVue>
        </div>
      </v-card-text>
    </v-card> -->

    <!-- <v-card class="qr-card-support" elevation="1" width="250" rounded="lg">
      <v-card-text class="pa-4">
        <div class="d-flex align-center gap-4">
          <div class="flex-grow-1">
            <p class="text font-weight-medium text-center pr-4">
              Precisa de ajuda? Aponte sua câmera para este QRCode e fale
              conosco!
            </p>
          </div>
          <QrcodeVue
            :value="'https://api.whatsapp.com/send?phone=5582991229510'"
            size="80"
          ></QrcodeVue>
        </div>
      </v-card-text>
    </v-card> -->
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import imageMemorial1 from "@/assets/propagandas/painel/01_PainelFinados2026.jpg";
import imageMemorial2 from "@/assets/propagandas/painel/02_PainelFinados2026.jpg";
import imageMemorial3 from "@/assets/propagandas/painel/03_PainelFinados2026.jpg";
import imageMemorial4 from "@/assets/propagandas/painel/04_PainelFinados2026.jpg";
import imageMemorial5 from "@/assets/propagandas/painel/05_PainelFinados2026.jpg";
import imageMemorial7 from "@/assets/propagandas/painel/07_PainelFinados2026.jpg";
import imageMemorial8 from "@/assets/propagandas/painel/08_PainelFinados2026.jpg";
import imageMemorial9 from "@/assets/propagandas/painel/09_PainelFinados2026.jpg";
// import videoMemorial1 from "@/assets/videos/1.mp4";
// import videoMemorial2 from "@/assets/videos/2.mp4";
// import videoMemorial3 from "@/assets/videos/3.mp4";
// import videoMemorial4 from "@/assets/videos/4.mp4";

export default {
  components: { QrcodeVue },
  data() {
    return {
      cards: [],
      currentCardIndex: 0,
      cardTimer: null,
      cardRotationInterval: 30000, // 30 segundos
      cardFetchInterval: 180000, // 3 minutos
      cardFetchTimer: null,
      videoInterval: null,
      timer: null,

      // Controle de propaganda
      showPropaganda: false,
      reproduzindo: false,
      tipoConteudoAtual: null,
      itemAtual: null,
      indiceAtual: 0,
      duracaoImagem: 30, // 30 segundos para cada imagem
      proximoVideoUrl: null, // URL do próximo vídeo para pré-carregamento
      videoPreloadThreshold: 3, // Segundos antes do fim para pré-carregar o próximo vídeo
      // Playlist de propaganda completa (todas em sequência, 30s cada)
      todasImagens: [
        { tipo: "imagem", url: imageMemorial1, duracao: 30 },
        { tipo: "imagem", url: imageMemorial2, duracao: 30 },
        { tipo: "imagem", url: imageMemorial3, duracao: 30 },
        { tipo: "imagem", url: imageMemorial4, duracao: 30 },
        { tipo: "imagem", url: imageMemorial5, duracao: 30 },
        { tipo: "imagem", url: imageMemorial7, duracao: 30 },
        { tipo: "imagem", url: imageMemorial8, duracao: 30 },
        { tipo: "imagem", url: imageMemorial9, duracao: 30 },
      ],

      // Playlist atual (todas as imagens por ciclo de propaganda)
      playlist: [],
      
    };
  },
  computed: {
  cardsVisiveis() {
  return this.cards.slice(this.currentCardIndex, this.currentCardIndex + 6);
},
primeiraLinhaCards() {
  return this.cardsVisiveis.slice(0, 3);
},
segundaLinhaCards() {
  return this.cardsVisiveis.slice(3, 6);
},
terceiraLinhaCards() {
  return [];
},
    qrCodeValue() {
      return "https://parquedasrecordacoes.com.br/painel-enviar-mensagem";
    },
  },
  methods: {
    truncateString(str) {
      return str.length > 10 ? str.substring(0, 10) + "..." : str;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    rotateCards() {
      // Não rotacionar os cards se o vídeo estiver sendo exibido
      if (!this.showPropaganda) {
        const nextIndex = this.currentCardIndex + 6;
        if (nextIndex >= this.cards.length) {
          this.consultarMensagens();
          this.currentCardIndex = 0;
        } else {
          this.currentCardIndex = nextIndex;
        }
      }
    },

    startPropagandaSequence() {
      this.iniciarPlaylist();
    },

    // Clique na tela principal: pula a espera e inicia as propagandas
    onPainelClick() {
      if (this.showPropaganda || this.reproduzindo) return;
      this.pularParaPropaganda();
    },

    pularParaPropaganda() {
      if (this.reproduzindo) return;
      if (this.videoInterval) {
        clearInterval(this.videoInterval);
        this.videoInterval = null;
      }
      this.startPropagandaSequence();
    },

    // Clique na propaganda: avança para a próxima (ou volta às mensagens)
    pularPropaganda() {
      this.proximoItem();
    },

    // Espaço / seta direita também pulam (útil no PC do telão)
    onTeclaPular(event) {
      if (event.key !== " " && event.key !== "ArrowRight") return;
      event.preventDefault();
      if (this.showPropaganda) {
        this.pularPropaganda();
      } else {
        this.pularParaPropaganda();
      }
    },

    iniciarPlaylist() {
      // Carrega todas as imagens: 30s cada, depois volta à tela principal
      this.playlist = [...this.todasImagens];

      if (this.playlist.length === 0) {
        this.finalizarPropaganda();
        return;
      }

      this.indiceAtual = 0;
      this.reproduzindo = true;
      this.showPropaganda = true;

      this.carregarItemAtual();
    },

    carregarItemAtual() {
      // Verifica se há itens na playlist
      if (this.indiceAtual >= this.playlist.length) {
        this.finalizarPropaganda();
        return;
      }

      // Carrega o item atual
      this.itemAtual = this.playlist[this.indiceAtual];
      this.tipoConteudoAtual = this.itemAtual.tipo;

      console.log(`Carregando ${this.tipoConteudoAtual}:`, this.itemAtual.url);

      // Pré-carrega o próximo vídeo se houver
      this.precarregarProximoVideo();
    },

    proximoItem() {
      // Sai do modo tela cheia se estiver
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {});
      }

      // Limpa qualquer timer existente
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      // Avança para o próximo item
      this.indiceAtual++;

      // Se chegou ao fim da playlist, finaliza a propaganda
      if (this.indiceAtual >= this.playlist.length) {
        this.finalizarPropaganda();
        return;
      }

      // Carrega o próximo item
      this.carregarItemAtual();
    },

    handleTimeUpdate() {
      // Se for vídeo e estiver próximo do final, pré-carrega o próximo
      const videoElement = this.$refs.videoPlayer;
      if (videoElement && this.tipoConteudoAtual === "video") {
        const timeLeft = videoElement.duration - videoElement.currentTime;

        // Se estiver próximo do final do vídeo, pré-carrega o próximo
        if (timeLeft <= this.videoPreloadThreshold) {
          this.precarregarProximoVideo();
        }
      }
    },

    precarregarProximoVideo() {
      // Verifica se o próximo item é um vídeo
      const proximoIndice = this.indiceAtual + 1;
      if (proximoIndice < this.playlist.length) {
        const proximoItem = this.playlist[proximoIndice];
        if (proximoItem.tipo === "video") {
          this.proximoVideoUrl = proximoItem.url;
          console.log("Pré-carregando próximo vídeo:", this.proximoVideoUrl);
        } else {
          this.proximoVideoUrl = null;
        }
      } else {
        this.proximoVideoUrl = null;
      }
    },

    iniciarTimerImagem() {
      // Limpa qualquer timer existente
      if (this.timer) {
        clearTimeout(this.timer);
      }

      // Define o tempo de exibição da imagem (usa o valor específico do item ou o padrão)
      const duracao = this.itemAtual.duracao || this.duracaoImagem;
      console.log(`Imagem será exibida por ${duracao} segundos`);

      this.timer = setTimeout(() => {
        this.proximoItem();
      }, duracao * 1000);
    },

    pararPlaylist() {
      // Limpa qualquer timer existente
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      // Para a reprodução
      this.reproduzindo = false;
      this.showPropaganda = false;
      this.tipoConteudoAtual = null;
      this.itemAtual = null;
    },

    finalizarPropaganda() {
      this.pararPlaylist();
      this.startVideoInterval(); // Reinicia o intervalo para a próxima propaganda
    },

    handleVideoError() {
      console.log("Erro ao reproduzir vídeo, passando para o próximo item");
      this.proximoItem();
    },

    startVideoInterval() {
      // Limpa qualquer intervalo existente
      if (this.videoInterval) {
        clearInterval(this.videoInterval);
      }

      // Mostrar propaganda a cada 3 minutos (180000ms)
      this.videoInterval = setInterval(() => {
        if (!this.reproduzindo) {
          this.startPropagandaSequence();
        }
      }, 180000); // 3 minutos
    },

    consultarMensagens() {
      http
        .get(
          "homenagem/eventos/aprovados",
          {
            params: {
              nomeEvento: "Finados2026",
              nomeEmpresa: "Memorial Parque Maceió",
            },
          },
          {
            headers: authHeader(),
          }
        )
        .then((response) => {
          this.cards = response.data;
        })
        .catch((error) => {
          console.error("Erro ao buscar mensagens:", error);
        });
    },
  },

  created() {
    this.consultarMensagens();
    setInterval(this.rotateCards, 30000);
    this.startVideoInterval();
    window.addEventListener("keydown", this.onTeclaPular);
  },

  beforeUnmount() {
    // Limpa todos os timers ao desmontar o componente
    if (this.cardTimer) clearTimeout(this.cardTimer);
    if (this.cardFetchTimer) clearTimeout(this.cardFetchTimer);
    if (this.videoInterval) clearInterval(this.videoInterval);
    if (this.timer) clearTimeout(this.timer);
    window.removeEventListener("keydown", this.onTeclaPular);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

.painel-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.painel-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("@/assets/propagandas/painel/PainelFinados2026.jpg");
  background-size: cover;
  background-position: center;
  transform: scale(1);
  z-index: 0;
}

.painel-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(18, 38, 77, 0) 0%,
    rgba(18, 38, 77, 0) 50%,
    rgba(18, 38, 77, 0) 100%
  );
  z-index: 1;
}

.banner {
  display: flex;
  align-items: center;
  height: 12vh;
  position: relative;
  flex-shrink: 0;
  z-index: 2;
}

.banner-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex: 1;
  width: 100%;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
}

.title-center {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  white-space: nowrap;
  background-color: #4e859b;
  padding: 0.5rem;
  border-radius: 8px;
}

.title-center h1 {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin: 0;
}

.title-container h1 {
  font-size: 2.5rem;
  font-weight: 500;
  text-align: center;
  flex: 1;
  white-space: nowrap;
}

.logo-placeholder {
  width: 116px; /* igual ao width da logo + margin */
  height: 1px;
}

.flower-icon {
  color: white;
  opacity: 0.9;
}

.cards-container {
  flex: 1;
  min-height: 60vh;
  position: relative;
  z-index: 2;
  padding-right: 0.6rem;
  margin: 10vh auto 0 31vw;
  width: 64vw;
}

.card-header {
  padding: 10px 18px;
  color: white;
  font-weight: 500;
}

.nome-mae {
  font-size: 1.3em;
  text-transform: uppercase;
}

.gradient-1 {
  background: linear-gradient(135deg, #3d768a, #5a9cbf);
}

.gradient-2 {
  background: linear-gradient(135deg, #2f5d6e, #417d97);
}

.gradient-3 {
  background: linear-gradient(135deg, #417d97, #74b3d4);
}

.gradient-4 {
  background: linear-gradient(135deg, #356f83, #4f8fae);
}

.gradient-5 {
  background: linear-gradient(135deg, #4a8aa8, #74b3d4);
}

.memorial-message {
  font-size: 21px;
  line-height: 1.5;
  color: #2c3e50;
  margin-bottom: 16px;
  font-weight: 500;
  overflow: auto;
}
.memorial-author {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 4px;
  margin-top: auto; /* <-- adicione esta linha */
}

.v-card-text.pa-4 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.author-name {
  font-size: 16px;
  color: #78909c;
  font-weight: 600;
  text-transform: capitalize !important;
  font-style: italic;
}

.author-date {
  font-size: 14px;
  color: #78909c;
}

.v-card.h-100,
.v-card.h-100 * {
  font-family: "Inter", sans-serif;
}

.v-card.h-100 {
  width: calc(100% - 0.75rem);
  height: 28vh;
  min-height: 28vh;
  max-height: 28vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.v-col {
  box-sizing: border-box;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-bottom: 2rem;
}
.v-row {
  flex-wrap: nowrap !important;
  gap: 24px !important;
}

.qr-card {
  position: fixed;
  bottom: 11.5vh;
  left: 20vw;
  transform: translateX(-50%);
  z-index: 10;
  padding: 0;
}

.qr-card-support {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  z-index: 10;
}

.card-transition-move {
  transition: transform 0.8s ease;
}

.card-transition-enter-active {
  transition: all 0.8s ease;
}

.card-transition-leave-active {
  transition: all 0.8s ease;
  position: absolute;
}

.card-transition-enter-from,
.card-transition-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.v-row {
  margin: 0;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
}

.v-col {
  padding: 12px;
  margin-bottom: 0.5rem;
}

.video-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 1); /* Fundo totalmente preto */
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.video-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.next-video {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.propaganda-image {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
}

/* Transição de slide para vídeos e imagens */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter-from {
  transform: translateX(30px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-30px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
